import { createRouter, createWebHistory } from 'vue-router'
import Auth from '@/modules/freetier/services/authservice';
import { store } from '@/store';

const router = createRouter({
    history: createWebHistory(),
    routes: []
})
router.beforeEach((to, from, next) => {
    let userLocation = localStorage.getItem('location');
    if (to.meta.requiresAuth) {
        if (store.getters['freetier/isAuthenticated'] &&  to.meta.isFreeTierAccess) {
            if (userLocation == to.meta.location) {
                next()
            } else {
                next()
            }
        }
        if (store.getters['client/isAuthenticated'] && to.meta.isClientAccess) {
            if (userLocation == to.meta.location) {
                next()
            } else {
                next()
            }
        }
        if (store.getters['talent/isAuthenticated'] && to.meta.isTalentAccess) {
            next()
        } else {
            if (to.meta.isClientAccess) {
                next('/client')
            }
             else if (to.meta.isTalentAccess) {
                next('/talent')
            } else if (to.meta.isFreeTierAccess) {
                next('/free-tier/login')
            } else {
                next('/')
            }
        }
    } else {
        next();
    }
})
export default router